import React, { useEffect } from 'react';

import './RecommendAddPage.css';

import backIcon from './../../image/back.png';
import axios from 'axios';

const RecommendAddPage = ({
    setCurrentPage,
    newRecommAddress,
    newRecommCoords,
    setNewRecommAddress,
    setNewRecommCoords,
    nameRu,
    nameEn,
    descriptionRu,
    descriptionEn,
    image,
    userList,
    userValue,
    userId,
    categories,
    selectSubCategory,
    activeCategoryList,
    responseSubCategory,
    endDate,
    setNameRu,
    setNameEn,
    setDescriptionRu,
    setDescriptionEn,
    setImage,
    setUserList,
    setUserValue,
    setUserId,
    setCategories,
    setSelectSubCategory,
    setActiveCategoryList,
    setResponseSubCategory,
    setEndDate,
    dateTimeRef,
}) => {
    // получение категорий
    useEffect(() => {
        const loadingCategories = async () => {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/manage/categories',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                    }
                );

                if (response.data.success) {
                    console.log('Категории: ', response.data.result);
                    setCategories(response.data.result);
                }
            } catch (error) {
                console.error('Ошибка при получении категорий ', error);
            }
        };
        loadingCategories();
    }, []);

    // открыть календарь
    const handleDateClick = () => {
        if (
            dateTimeRef.current &&
            typeof dateTimeRef.current.showPicker === 'function'
        ) {
            dateTimeRef.current.showPicker();
        }
    };

    // дата
    const handleDateChange = (e) => {
        setEndDate(e.target.value);
    };

    // клик назад
    const handleBackClick = () => {
        setCurrentPage('Recommendations');
        setNewRecommAddress(null);
        setNewRecommCoords(null);
    };

    // клик на адрес
    const handleMapClick = () => {
        setCurrentPage('MapPage');
    };

    // обработка картинки
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // пользователи
    const handleUserListClick = async (e) => {
        const value = e.target.value;
        setUserList(value);
        if (value.length >= 3) {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/manage/users/name/find',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            name: value,
                        },
                    }
                );
                if (response.data.success) {
                    setUserValue(response.data.result);
                    console.log('Пользователи: ', response.data.result);
                }
            } catch (error) {
                console.error('Ошибка получения пользователей ', error);
            }
        }
    };

    const handleUserClick = (userId) => {
        setUserId(userId.id);
        setUserList(userId.name);
        setUserValue([]);
    };

    // клик по инпуту категорий
    const handleCategoryClick = () => {
        setActiveCategoryList(true);
    };

    // клик по подкатегории
    const handleSubCategoryClick = (subcategoryId) => {
        setSelectSubCategory(subcategoryId);
        setResponseSubCategory(subcategoryId.id);
        setActiveCategoryList(false);
    };

    const handleSaveClick = async () => {
        try {
            const endDateUtc = new Date(endDate).toISOString();

            const response = await axios.post(
                'https://mepointserver.ru/manage/ad/create',
                {
                    eventSubCategoryId: responseSubCategory,
                    end: endDateUtc,
                    city: newRecommAddress.split(',')[0].trim(),
                    latitude: newRecommCoords[0],
                    longitude: newRecommCoords[1],
                    address: newRecommAddress,
                    image: image ? image.split(';base64,')[1] : null,
                    nameRu: nameRu,
                    nameEn: nameEn,
                    descriptionRu: descriptionRu,
                    descriptionEn: descriptionEn,
                    userId: userId,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );
            if (response.data.success) {
                console.log('Рекомендация создана');
                setNameRu('');
                setNameEn('');
                setDescriptionRu('');
                setDescriptionEn('');
                setImage(null);
                setUserList('');
                setUserValue([]);
                setUserId('');
                setSelectSubCategory(null);
                setActiveCategoryList(false);
                setResponseSubCategory(null);
                setEndDate(new Date());
                setNewRecommAddress(null);
                setNewRecommCoords(null);
                setCurrentPage('Recommendations');
            }
        } catch (error) {
            console.error('Ошибка создания рекомендации ', error);
        }
    };

    return (
        <div className='edit__wrapper'>
            <div className='edit__back' onClick={handleBackClick}>
                <img src={backIcon} alt='back' />
            </div>
            <h1 className='edit__title'>Добавить реакомендацию</h1>
            <div className='edit__items'>
                <div className='edit__item_name'>
                    <h3>Название (Ru)</h3>
                    <input
                        type='text'
                        value={nameRu}
                        onChange={(e) => setNameRu(e.target.value)}
                    />
                </div>

                <div className='edit__item_name'>
                    <h3>Название (En)</h3>
                    <input
                        type='text'
                        value={nameEn}
                        onChange={(e) => setNameEn(e.target.value)}
                    />
                </div>

                <div className='edit__item_name'>
                    <h3>Описание (Ru)</h3>
                    <textarea
                        rows={3}
                        value={descriptionRu}
                        onChange={(e) => setDescriptionRu(e.target.value)}
                    ></textarea>
                </div>

                <div className='edit__item_name'>
                    <h3>Описание (En)</h3>
                    <textarea
                        rows={3}
                        value={descriptionEn}
                        onChange={(e) => setDescriptionEn(e.target.value)}
                    ></textarea>
                </div>

                <div className='edit__item_name'>
                    <h3>Адрес</h3>
                    <div className='recommend__input_item'>
                        <p>{newRecommAddress}</p>
                    </div>
                    <div
                        className='recommend__address_btn'
                        onClick={handleMapClick}
                    >
                        Указать адрес
                    </div>
                </div>

                <div className='recommend__item_name'>
                    <div className='recommend__items_name'>
                        <h3>Широта</h3>
                        <div className='recommend__input_item'>
                            <p>{newRecommCoords && newRecommCoords[0]}</p>
                        </div>
                    </div>

                    <div className='recommend__items_name'>
                        <h3>Долгота</h3>
                        <div className='recommend__input_item'>
                            <p>{newRecommCoords && newRecommCoords[1]}</p>
                        </div>
                    </div>
                </div>

                <div className='edit__item_name'>
                    <h3>Изображение</h3>
                    <div className='edit__image_items'>
                        <input
                            type='file'
                            accept='image/*'
                            onChange={handleImageChange}
                            className='image__change'
                            id='imageEdit'
                        />
                        <label htmlFor='imageEdit'>
                            <img src={image} alt={image !== null && 'image'} />
                        </label>
                    </div>
                </div>

                <div className='recommend__item_user'>
                    <div className='recommend__items_user'>
                        <h3>Подкатегория</h3>
                        <div
                            className='recommend__input_item'
                            onClick={handleCategoryClick}
                        >
                            {selectSubCategory && selectSubCategory.nameRu}
                        </div>
                    </div>
                    <div
                        className={`recommend__list ${
                            activeCategoryList ? 'active' : ''
                        }`}
                    >
                        {categories.map((category) => (
                            <div
                                key={category.id}
                                className='recommend__category'
                            >
                                <h3>{category.nameRu}</h3>
                                <div className='recommend__subcategory'>
                                    {category.subcategories.map(
                                        (subcategory) => (
                                            <p
                                                key={subcategory.id}
                                                onClick={() =>
                                                    handleSubCategoryClick(
                                                        subcategory
                                                    )
                                                }
                                            >
                                                {subcategory.nameRu}
                                            </p>
                                        )
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className='recommend__item_user'>
                    <div className='recommend__items_user'>
                        <h3>Пользователь</h3>
                        <input
                            type='text'
                            onChange={handleUserListClick}
                            value={userList}
                        />
                    </div>
                    <div
                        className={`recommend__list ${
                            userValue.length > 0 ? 'active' : ''
                        }`}
                    >
                        {userValue.map((user) => (
                            <p
                                className='recommend__user_name'
                                key={user.id}
                                onClick={() => handleUserClick(user)}
                            >
                                {user.name}
                            </p>
                        ))}
                    </div>
                </div>

                <div className='edit__item_name'>
                    <h3>Дата окончания</h3>
                    <input
                        value={endDate}
                        type='datetime-local'
                        ref={dateTimeRef}
                        onClick={handleDateClick}
                        onChange={handleDateChange}
                    />
                </div>
            </div>
            <div className='edit__btn' onClick={handleSaveClick}>
                Сохранить
            </div>
        </div>
    );
};

export default RecommendAddPage;
